import { useCallback } from 'react'

import { stringToBoolean } from '../utils'
import { useLocalStorage } from './useLocalStorage'
import { useStorage } from './useStorage'

/**
 * Хук, позволяющий включить показ какого-либо тултипа через localStorage
 *
 * Используется строгое сравнение:
 * ```ts
 * countShowTooltip < timesToShow
 * ```
 *
 * Должен использоваться в паре с {@link useCountableTooltip}
 *
 * @param countIdentifier {@link useCountableTooltip смотри здесь}
 * @param timesToShow Количество раз, сколько нужно показать тултип
 * @returns Функция, которая пытается включить тултип, если количество показов не вышло
 */
export const useShowCountableTooltip = (countIdentifier: string, timesToShow: number) => {
  const [countShowTooltip] = useStorage(`countShow${countIdentifier}Tooltip`, Number, String, 0)
  const [, setShowTooltip] = useLocalStorage(
    `show${countIdentifier}Tooltip`,
    stringToBoolean,
    String,
    false,
  )

  const tryToShowTooltip = useCallback(() => {
    if (countShowTooltip < timesToShow) {
      setShowTooltip(true)
    }
  }, [countShowTooltip, setShowTooltip, timesToShow])

  return { tryToShowTooltip }
}
